import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { DateHelperService } from 'src/app/core/helpers/date-helper/date-helper.service';
import { AppointmentTimeEntry } from 'src/app/core/models/appointment-time-entry.model';
import { ConfigSetting } from 'src/app/core/models/config-settings.model';
import { TimeEntry } from 'src/app/core/models/time-entry.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { TimeEntryService } from 'src/app/core/time-entry/time-entry.service';
import { TimeTrackingFormComponent } from 'src/app/pages/time-tracking-form/time-tracking-form.component';
@Component({
	selector: 'app-time-entry-toggle-section',
	templateUrl: './time-entry-toggle-section.component.html',
	styleUrls: ['./time-entry-toggle-section.component.scss']
})
export class TimeEntryToggleSectionComponent implements OnInit {

	@Input()
	timeEntry: TimeEntry;

	@Input()
	apptTimeEntry: AppointmentTimeEntry;

	@Input()
	techId: number;

	@Input()
	color = 'light';

	@Input()
	lines = 'full';

	@Output()
	changed = new EventEmitter<boolean>();

	@Input()
	DisableEditOnCleared: ConfigSetting;

	readonly = true;

	constructor(
		private dateHelper: DateHelperService,
		private modalController: ModalController,
		private timeEntryService: TimeEntryService,
		private alertController: AlertController,
		private appointmentService: AppointmentService,
	) { }

	async ngOnInit() {
		this.readonly = await this.isReadOnly(this.apptTimeEntry);
	}

	getMinutesFormatted(minutes: number): string {
		const time = this.dateHelper.getHoursMinutesFromMinutes(minutes);

		return `${time.hours}h ${time.minutes}m`;
	}

	async canDelete(): Promise<boolean> {
		return this.apptTimeEntry.techId === this.techId;
	}

	async isReadOnly(entry: AppointmentTimeEntry): Promise<boolean> {
		// Always allow editing 'Other' appointments
		if (this.apptTimeEntry.apptId === -2000) {
			return false;
		}

		if (this.techId !== entry.techId) {
			return true;
		}

		if (this.DisableEditOnCleared.value === 'True') {
			const appt = await this.appointmentService.getLocalAppointment(entry.apptId);
			return (appt?.ticketStatusIsEndStatus);
		}

		return false;
	}

	async onClickShowForm(): Promise<void> {
		const modal = await this.modalController.create({
			component: TimeTrackingFormComponent,
			componentProps: {
				mode: 'Edit',
				timeEntry: this.timeEntry,
				apptTimeEntry: this.apptTimeEntry,
			},
			cssClass: 'full-screen-modal',
		});

		await modal.present();
		await modal.onDidDismiss();
		this.changed.emit(true);
	}

	async onClickDeleteTimeEntry(): Promise<void> {
		const alert = await this.alertController.create({
			header: 'Confirm Delete',
			message: 'Are you sure you would like to delete this time entry?',
			backdropDismiss: false,
			buttons: [
				{
					text: 'No',
					role: 'cancel',
					cssClass: 'secondary',
				},
				{
					text: 'Yes',
					handler: async () => await this.deleteTimeEntry(this.timeEntry),
				}
			]
		});

		await alert.present();
	}

	async deleteTimeEntry(timeEntry: TimeEntry): Promise<void> {
		await this.timeEntryService.deleteTimeEntry(timeEntry, this.apptTimeEntry.apptId, this.apptTimeEntry.techId);
		this.changed.emit(true);
	}
}
